import { defaultAttributes } from '../styles';
var colors = defaultAttributes.colors; // MUI palette:

var palette = {
  error: {
    main: colors.errorRed
  },
  grey: {
    400: colors.ultraLightGrey
  },
  primary: {
    contrastText: colors.white,
    dark: colors.blue,
    light: colors.actionHover,
    main: colors.adminBlue
  },
  secondary: {
    contrastText: colors.darkGrey,
    dark: colors.nearWhite,
    light: colors.white,
    main: colors.white
  },
  text: {
    disabled: colors.ultraLightGrey,
    hint: colors.defaultGrey,
    primary: colors.darkGrey,
    secondary: colors.mediumGrey
  }
};
export default palette;